import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="mt-5">
      <div className="container text-center">
        <p>주소: 서울특별시 영등포구 당산로32길 13 지성빌딩 4층</p>
        <p>© 2025 BaryBary. All Rights Reserved.</p>
        <p>시스템 문의: 1544-1485</p>
      </div>
    </footer>
  );
};

export default Footer;
